import React from 'react';
import { Link } from 'react-router-dom';
import { ComingSoonPage } from '@components/ui/pages';
import { useAuditEnabled } from '@features/jotaudit';
import { Button } from '@mui/material';
import { useEventTracking } from '@services/statsig';

import { useTracking } from '../../../context/TrackingContext';
import { EventType } from '../../../types/events';

/**
 * BillInsurancePage Component
 *
 * A "coming soon" page for the Bill Insurance feature.
 * Displays information about the upcoming billing insurance feature
 * with CTAs for learning more and accessing rules.
 */
export const BillInsurancePage: React.FC = () => {
  const { billing } = useEventTracking();
  const { trackEvent } = useTracking();
  const isAuditEnabled = useAuditEnabled();

  const handleLearnMoreClick = () => {
    billing.learnMoreClicked({
      destination_url: 'https://calendly.com/npeereboom/jotpsych-billing-services-intro-call',
    });
    trackEvent(EventType.EXPRESSED_INTEREST, {
      feature: 'bill_insurance',
    });
  };

  const handleRulesClick = () => {
    billing.rulesClicked({
      destination_path: '/rules',
    });
  };

  return (
    <ComingSoonPage
      title="Bill Insurance"
      showHeader={false}
      action={
        isAuditEnabled ? (
          <Button
            component={Link}
            to="/rules"
            variant="contained"
            color="secondary"
            onClick={handleRulesClick}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            Your Rules
          </Button>
        ) : undefined
      }
      heroTitle="Bill Insurance"
      description="Your notes. Our AI + humans. Clean claims, every time."
      primaryAction={{
        label: 'Learn more',
        href: 'https://calendly.com/npeereboom/jotpsych-billing-services-intro-call',
        external: true,
        onClick: handleLearnMoreClick,
        startIcon: null,
      }}
    />
  );
};
